// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1ed8b280","94":"45dac42b","213":"f4653677","402":"b3f4b20d","455":"3940eed1","480":"96e5e33e","607":"f47c5dd1","638":"001e6187"}[chunkId] + ".chunk.js";
};